import React from 'react';
import {
  Box,
  Checkbox,
  CustomText,
  DatePicker,
  Field,
  FilePicker,
  Input,
  NewCheckbox,
  NewDatePicker,
  NewInput,
  NewRadio,
  NewSelect,
  NewTable,
  NewTextArea,
  NewTypeahead,
  Radio,
  Select,
  SelectableList,
  Status,
  Table,
  TableBodyRow,
  TableCell,
  TextArea,
  Typeahead,
  VStack,
} from '@carta/ink';

import ExposeDescribe from '../components/ExposeDescribe';

const FormComponentsExpose = () => {
  const [typeaheadValue1, setTypeaheadValue1] = React.useState('');
  const typeaheadOptionLabel = option => option.label;
  const typeaheadOptions = [{ label: 'Batman' }, { label: 'Chapulin Colorado' }];
  const typeaheadFilteredOptions = value => typeaheadOptions.filter(option => option.label.includes(value));

  return (
    <>
      <ExposeDescribe
        id="comprehensive-newinput-interactive-states-test"
        name="Comprehensive test of NewInput interactive states"
        key="comprehensive-newinput-interactive-states-test"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal NewInput">
            <NewInput id="normal-newinput" />
          </Field>

          {/* Hovered state */}
          <Field label="NewInput on hover">
            <NewInput id="newinput-on-hover" />
          </Field>

          {/* Focused state */}
          <Field label="NewInput on focus">
            <NewInput id="newinput-on-focus" />
          </Field>

          {/* With placeholder text */}
          <Field label="NewInput with placeholder">
            <NewInput id="newinput-with-placeholder" placeholder="Placeholder" />
          </Field>

          {/* With set value */}
          <Field label="NewInput with value">
            <NewInput id="newinput-with-value" value="Batman" />
          </Field>

          {/* With set value */}
          <Field label="NewInput with value">
            <NewInput id="newinput-with-value" value="Batman" width="half" inline />
            <NewInput id="newinput-with-value" value="Batman" width="half" inline />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and NewInput error states"
            error="Remember to set both Field “error” and NewInput “invalid” props"
          >
            <NewInput id="newinput-error-state" value="Bruce Wayne" invalid />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and NewInput error states and focused"
            error="Remember to set both Field “error” and NewInput “invalid” props"
          >
            <NewInput id="newinput-error-state-on-focus" value="Bruce Wayne" invalid />
          </Field>

          {/* Disabled state */}
          <Field label="NewInput when disabled">
            <NewInput id="newinput-when-disabled" value="Bruce Wayne" disabled />
          </Field>

          {/* Disabled and invalid check */}
          <Field
            label="NewInput when invalid and disabled"
            help="Checks for potential CSS clashes disabled and invalid"
          >
            <NewInput id="newinput-disabled-and-invalid" value="Bruce Wayne" invalid disabled />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-inputs-within-newtable-interactive-states-test"
        name="Comprehensive test of modern inputs in the context of a NewTable"
        key="comprehensive-inputs-within-newtable-interactive-states-test"
      >
        <NewTable>
          <NewTable.Head>
            <NewTable.Row>
              <NewTable.HeadCell>NewInput</NewTable.HeadCell>
              <NewTable.HeadCell>NewSelect</NewTable.HeadCell>
              <NewTable.HeadCell>NewTypeahead</NewTable.HeadCell>
              <NewTable.HeadCell>NewTextArea</NewTable.HeadCell>
              <NewTable.HeadCell>NewDatePicker</NewTable.HeadCell>
              <NewTable.HeadCell>FilePicker</NewTable.HeadCell>
            </NewTable.Row>
          </NewTable.Head>
          <NewTable.Body>
            <NewTable.Row>
              <NewTable.Cell>
                <NewInput width="half" />
              </NewTable.Cell>
              <NewTable.Cell>
                <NewSelect id="normal-newselect" width="half">
                  <NewSelect.Option value="" />
                  <NewSelect.Option value="Batman">Batman</NewSelect.Option>
                  <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
                </NewSelect>
              </NewTable.Cell>
              <NewTable.Cell>
                <NewTypeahead
                  id="table-newtypeahead-normal"
                  value={typeaheadValue1}
                  onChange={(_, { value }) => setTypeaheadValue1(value)}
                  options={typeaheadOptions}
                  optionLabel={typeaheadOptionLabel}
                  filterOptions={typeaheadFilteredOptions}
                  input={props => <NewInput {...props} id="table-newtypeahead-normal-input" width="half" />}
                />
              </NewTable.Cell>
              <NewTable.Cell>
                <NewTextArea id="table-normal-newtextarea" width="full" />
              </NewTable.Cell>
              <NewTable.Cell>
                <NewDatePicker
                  id="newtable-newdatepicker"
                  value=""
                  onChange={() => console.log('NewDatepicker onChange called')}
                />
              </NewTable.Cell>
              <NewTable.Cell>
                <FilePicker id="newtable-filepicker" size="full" />
              </NewTable.Cell>
            </NewTable.Row>
            <NewTable.Row>
              <NewTable.Cell preset="editable">
                <NewInput id="editable-table-newinput-embedded" />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewSelect id="normal-newselect-embedded">
                  <NewSelect.Option value="" />
                  <NewSelect.Option value="Batman">Batman</NewSelect.Option>
                  <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
                </NewSelect>
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTypeahead
                  id="table-newtypeahead-normal-embedded"
                  value={typeaheadValue1}
                  onChange={(_, { value }) => setTypeaheadValue1(value)}
                  options={typeaheadOptions}
                  optionLabel={typeaheadOptionLabel}
                  filterOptions={typeaheadFilteredOptions}
                  input={props => <NewInput {...props} id="table-newtypeahead-normal-embedded-input" />}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTextArea id="table-normal-newtextarea-embedded" />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewDatePicker
                  id="newtable-newdatepicker-embedded"
                  value=""
                  onChange={() => console.log('NewDatepicker onChange called')}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <FilePicker id="newtable-filepicker-embedded" />
              </NewTable.Cell>
            </NewTable.Row>
            <NewTable.Row>
              <NewTable.Cell preset="editable">
                <NewInput id="editable-table-newinput-hovered" />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewSelect id="newselect-when-hovered">
                  <NewSelect.Option value="" />
                  <NewSelect.Option value="Batman">Batman</NewSelect.Option>
                  <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
                </NewSelect>
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTypeahead
                  id="table-newtypeahead-on-hover"
                  value={typeaheadValue1}
                  onChange={(_, { value }) => setTypeaheadValue1(value)}
                  options={typeaheadOptions}
                  optionLabel={typeaheadOptionLabel}
                  filterOptions={typeaheadFilteredOptions}
                  input={props => <NewInput {...props} id="table-newtypeahead-on-hover-input" />}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTextArea id="table-newtextarea-on-hover" />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewDatePicker
                  id="newtable-newdatepicker-on-hover"
                  value=""
                  onChange={() => console.log('NewDatepicker onChange called')}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <FilePicker id="newtable-filepicker-when-hovered" />
              </NewTable.Cell>
            </NewTable.Row>
            <NewTable.Row>
              <NewTable.Cell preset="editable">
                <NewInput id="editable-table-newinput-focused" />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewSelect id="newselect-when-focused">
                  <NewSelect.Option value="" />
                  <NewSelect.Option value="Batman">Batman</NewSelect.Option>
                  <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
                </NewSelect>
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTypeahead
                  id="table-newtypeahead-on-focus"
                  value={typeaheadValue1}
                  onChange={(_, { value }) => setTypeaheadValue1(value)}
                  options={typeaheadOptions}
                  optionLabel={typeaheadOptionLabel}
                  filterOptions={typeaheadFilteredOptions}
                  input={props => <NewInput {...props} id="table-newtypeahead-on-focus-input" />}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTextArea id="table-newtextarea-on-focus" />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewDatePicker
                  id="newtable-newdatepicker-on-focus"
                  value=""
                  onChange={() => console.log('NewDatepicker onChange called')}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <FilePicker id="newtable-filepicker-when-focused" />
              </NewTable.Cell>
            </NewTable.Row>
            <NewTable.Row>
              <NewTable.Cell preset="editable">
                <NewInput id="editable-table-newinput-placeholder" placeholder="Batman" />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewSelect id="newselect-with-placeholder">
                  <NewSelect.Option value="">Choose your favorite superhero</NewSelect.Option>
                  <NewSelect.Option value="Batman">Batman</NewSelect.Option>
                  <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
                </NewSelect>
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTypeahead
                  id="table-newtypeahead-with-placeholder"
                  value={typeaheadValue1}
                  onChange={(_, { value }) => setTypeaheadValue1(value)}
                  options={typeaheadOptions}
                  optionLabel={typeaheadOptionLabel}
                  filterOptions={typeaheadFilteredOptions}
                  input={props => (
                    <NewInput
                      {...props}
                      id="table-newtypeahead-with-placeholder-input"
                      placeholder="Favorite superhero"
                    />
                  )}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTextArea id="table-newtextarea-with-placeholder" placeholder="Favorite superhero quote" />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewDatePicker
                  id="newtable-newdatepicker-with-placeholder"
                  placeholder="MM/DD/YYYY"
                  value=""
                  onChange={() => console.log('NewDatepicker onChange called')}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">N/A</NewTable.Cell>
            </NewTable.Row>
            <NewTable.Row>
              <NewTable.Cell preset="editable">
                <NewInput id="editable-table-newinput-with-value" value="Batman" />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewSelect id="newselect-when-option-is-selected" value="Chapulin">
                  <NewSelect.Option value="" />
                  <NewSelect.Option value="Batman">Batman</NewSelect.Option>
                  <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
                </NewSelect>
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTypeahead
                  id="table-newtypeahead-with-value"
                  value="Chapulin Colorado"
                  onChange={(_, { value }) => setTypeaheadValue1(value)}
                  options={typeaheadOptions}
                  optionLabel={typeaheadOptionLabel}
                  filterOptions={typeaheadFilteredOptions}
                  input={props => <NewInput {...props} id="table-newtypeahead-with-value-input" />}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTextArea id="newtextarea-with-value" value="¡Siganme los buenos!" />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewDatePicker
                  id="newtable-newdatepicker-with-value"
                  value="08/01/1983"
                  onChange={() => console.log('NewDatepicker onChange called')}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <FilePicker id="filepicker-with-value" value={[{ name: 'Chapulin.xls' }]} />
              </NewTable.Cell>
            </NewTable.Row>
            <NewTable.Row>
              <NewTable.Cell preset="editable">
                <NewInput id="editable-table-newinput-invalid" value="Batman" invalid />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewSelect id="newselect-when-invalid" value="Batman" invalid>
                  <NewSelect.Option value="" />
                  <NewSelect.Option value="Batman">Batman</NewSelect.Option>
                  <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
                </NewSelect>
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTypeahead
                  id="table-newtypeahead-invalid"
                  value={typeaheadValue1}
                  onChange={(_, { value }) => setTypeaheadValue1(value)}
                  options={typeaheadOptions}
                  optionLabel={typeaheadOptionLabel}
                  filterOptions={typeaheadFilteredOptions}
                  input={props => <NewInput {...props} id="table-newtypeahead-invalid-input" invalid />}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTextArea id="table-newtextarea-invalid" value="Time is money!" invalid />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewDatePicker
                  id="newtable-newdatepicker-when-invalid"
                  value="08/01/1983"
                  onChange={() => console.log('NewDatepicker onChange called')}
                  invalid
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <FilePicker
                  id="newtable-filepicker-when-invalid"
                  value={[{ name: 'Batman.xls' }]}
                  customError="Chapulin is the greatest hero of Hispanic-America"
                  isInvalid
                />
              </NewTable.Cell>
            </NewTable.Row>
            <NewTable.Row>
              <NewTable.Cell preset="editable">
                <NewInput id="editable-table-newinput-invalid-and-focused" value="Batman" invalid />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewSelect id="newselect-when-invalid-and-focused" value="Batman" invalid>
                  <NewSelect.Option value="" />
                  <NewSelect.Option value="Batman">Batman</NewSelect.Option>
                  <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
                </NewSelect>
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTypeahead
                  id="table-newtypeahead-invalid-and-focused"
                  value={typeaheadValue1}
                  onChange={(_, { value }) => setTypeaheadValue1(value)}
                  options={typeaheadOptions}
                  optionLabel={typeaheadOptionLabel}
                  filterOptions={typeaheadFilteredOptions}
                  input={props => <NewInput {...props} id="table-newtypeahead-invalid-and-focused-input" invalid />}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTextArea id="table-newtextarea-invalid-with-focus" value="Time is money!" invalid />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewDatePicker
                  id="newtable-newdatepicker-when-invalid-and-focused"
                  value="08/01/1983"
                  onChange={() => console.log('NewDatepicker onChange called')}
                  invalid
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <FilePicker
                  id="newtable-filepicker-when-invalid-and-focused"
                  value={[{ name: 'Batman.xls' }]}
                  customError="Chapulin is the greatest hero of Hispanic-America"
                  isInvalid
                />
              </NewTable.Cell>
            </NewTable.Row>
            <NewTable.Row>
              <NewTable.Cell preset="editable">
                <NewInput id="editable-table-newinput-disabled" value="Batman" disabled />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewSelect id="newselect-when-disabled" value="Batman" disabled>
                  <NewSelect.Option value="" />
                  <NewSelect.Option value="Batman">Batman</NewSelect.Option>
                  <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
                </NewSelect>
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTypeahead
                  id="table-newtypeahead-when-disabled"
                  value="Chapulin Colorado"
                  onChange={(_, { value }) => setTypeaheadValue1(value)}
                  options={typeaheadOptions}
                  optionLabel={typeaheadOptionLabel}
                  filterOptions={typeaheadFilteredOptions}
                  input={props => <NewInput {...props} id="table-newtypeahead-when-disabled-input" disabled />}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTextArea id="table-newtextarea-when-disabled" value="Time is money!" disabled />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewDatePicker
                  id="newtable-newdatepicker-when-disabled"
                  value="08/01/1983"
                  onChange={() => console.log('NewDatepicker onChange called')}
                  disabled
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <FilePicker id="newtable-filepicker-when-disabled" value={[{ name: 'Batman.xls' }]} disabled />
              </NewTable.Cell>
            </NewTable.Row>
            <NewTable.Row>
              <NewTable.Cell preset="editable">
                <NewInput id="editable-table-newinput-disabled-and-invalid" value="Batman" disabled invalid />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewSelect id="newselect-when-disabled-and-invalid" value="Batman" disabled invalid>
                  <NewSelect.Option value="" />
                  <NewSelect.Option value="Batman">Batman</NewSelect.Option>
                  <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
                </NewSelect>
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTypeahead
                  id="table-newtypeahead-when-disabled-and-invalid"
                  value="Chapulin Colorado"
                  onChange={(_, { value }) => setTypeaheadValue1(value)}
                  options={typeaheadOptions}
                  optionLabel={typeaheadOptionLabel}
                  filterOptions={typeaheadFilteredOptions}
                  input={props => (
                    <NewInput {...props} id="table-newtypeahead-when-disabled-and-invalid-input" disabled invalid />
                  )}
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewTextArea id="table-newtextarea-when-disabled-and-invalid" value="Time is money!" disabled invalid />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <NewDatePicker
                  id="newtable-newdatepicker-when-disabled-and-invalid"
                  onChange={() => console.log('NewDatepicker onChange called')}
                  value="08/01/1983"
                  invalid
                  disabled
                />
              </NewTable.Cell>
              <NewTable.Cell preset="editable">
                <FilePicker
                  id="newtable-filepicker-when-disabled-and-invalid"
                  value={[{ name: 'Batman.xls' }]}
                  disabled
                  isInvalid
                />
              </NewTable.Cell>
            </NewTable.Row>
          </NewTable.Body>
        </NewTable>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-newradio-interactive-states-test"
        key="comprehensive-newradio-interactive-states-test"
        name="Comprehensive test of NewRadio interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal NewRadio">
            <NewRadio id="new-radio-normal-state-a" name="new-radio-normal-state" value="Batman" label="Batman" />
            <NewRadio
              id="new-radio-normal-state-b"
              name="new-radio-normal-state"
              value="Chapulin"
              label="Chapulin Colorado"
            />
          </Field>

          {/* Hovered state */}
          <Field label="NewRadio when hovered">
            <NewRadio id="new-radio-hovered-state-a" name="new-radio-hovered-state" value="Batman" label="Batman" />
            <NewRadio
              id="new-radio-hovered-state-b"
              name="new-radio-hovered-state"
              value="Chapulin"
              label="Chapulin Colorado"
            />
          </Field>

          {/* Focused state */}
          <Field label="NewRadio when focused">
            <NewRadio id="new-radio-when-focused-a" name="new-radio-when-focused" value="Batman" label="Batman" />
            <NewRadio
              id="new-radio-when-focused-b"
              name="new-radio-when-focused"
              value="Chapulin"
              label="Chapulin Colorado"
            />
          </Field>

          {/* With set value */}
          <Field label="NewRadio when checked">
            <NewRadio id="new-radio-when-checked-a" name="new-radio-when-checked" value="Batman" label="Batman" />
            <NewRadio
              id="new-radio-when-checked-b"
              name="new-radio-when-checked"
              value="Chapulin"
              label="Chapulin Colorado"
              checked
            />
          </Field>

          {/* Side by side */}
          <Field label="NewRadio side by side">
            <NewRadio
              id="new-radio-side-by-side-a"
              name="new-radio-side-by-side"
              value="Batman"
              label="Batman"
              width="half"
              inline
            />
            <NewRadio
              id="new-radio-side-by-side-b"
              name="new-radio-side-by-side"
              value="Chapulin"
              label="Chapulin"
              width="half"
              inline
            />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and NewRadio error states"
            error="Remember Chapulin is the biggest hero of Hispanic-America"
          >
            <NewRadio
              id="new-radio-when-invalid-a"
              name="new-radio-when-invalid"
              value="Batman"
              label="Batman"
              invalid
              checked
            />
            <NewRadio
              id="new-radio-when-invalid-b"
              name="new-radio-when-invalid"
              value="Chapulin"
              label="Chapulin Colorado"
              invalid
            />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and NewRadio when in error state and focused"
            error="Remember to set both Field “error” and Input “invalid” props"
          >
            <NewRadio
              id="new-radio-when-invalid-and-focused-a"
              name="new-radio-when-invalid-and-focused"
              value="Batman"
              label="Batman"
              invalid
            />
            <NewRadio
              id="new-radio-when-invalid-and-focused-b"
              name="new-radio-group-base2"
              value="Chapulin"
              label="Chapulin Colorado"
              invalid
              checked
            />
          </Field>

          {/* Disabled state */}
          <Field label="NewRadio when disabled">
            <NewRadio
              id="new-radio-when-disabled-a"
              name="new-radio-when-disabled"
              value="Batman"
              label="Batman"
              disabled
            />
            <NewRadio
              id="new-radio-when-disabled-b"
              name="new-radio-when-disabled"
              value="Chapulin"
              label="Chapulin Colorado"
              disabled
              checked
            />
          </Field>

          {/* Disabled and invalid check */}
          <Field label="NewRadio when invalid and disabled, should just look disabled">
            <NewRadio
              id="new-radio-when-disabled-and-invalid-a"
              name="new-radio-when-disabled-and-invalid"
              value="Batman"
              label="Batman"
              disabled
              invalid
            />
            <NewRadio
              id="new-radio-when-disabled-and-invalid-b"
              name="new-radio-when-disabled-and-invalid"
              value="Chapulin"
              label="Chapulin Colorado"
              invalid
              disabled
              checked
            />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-newcheckbox-interactive-states-test"
        key="comprehensive-newcheckbox-interactive-states-test"
        name="Comprehensive test of NewCheckbox interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal NewCheckbox">
            <NewCheckbox
              id="newcheckbox-normal-state-a"
              name="newcheckbox-normal-state"
              value="Batman"
              label="Batman"
            />
            <NewCheckbox
              id="newcheckbox-normal-state-b"
              name="newcheckbox-normal-state"
              value="Chapulin"
              label="Chapulin Colorado"
            />
          </Field>

          {/* Hovered state */}
          <Field label="NewCheckbox when hovered">
            <NewCheckbox
              id="newcheckbox-hovered-state-a"
              name="newcheckbox-hovered-state"
              value="Batman"
              label="Batman"
            />
            <NewCheckbox
              id="newcheckbox-hovered-state-b"
              name="newcheckbox-hovered-state"
              value="Chapulin"
              label="Chapulin Colorado"
            />
          </Field>

          {/* Focused state */}
          <Field label="NewCheckbox when focused">
            <NewCheckbox
              id="newcheckbox-when-focused-a"
              name="newcheckbox-when-focused"
              value="Batman"
              label="Batman"
            />
            <NewCheckbox
              id="newcheckbox-when-focused-b"
              name="newcheckbox-when-focused"
              value="Chapulin"
              label="Chapulin Colorado"
            />
          </Field>

          {/* With set value */}
          <Field label="NewCheckbox when checked">
            <NewCheckbox
              id="newcheckbox-when-checked-a"
              name="newcheckbox-when-checked"
              value="Batman"
              label="Batman"
            />
            <NewCheckbox
              id="newcheckbox-when-checked-b"
              name="newcheckbox-when-checked"
              value="Chapulin"
              label="Chapulin Colorado"
              checked
            />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and NewCheckbox error states"
            error="Remember Chapulin is the biggest hero of Hispanic-America"
          >
            <NewCheckbox
              id="newcheckbox-when-invalid-a"
              name="newcheckbox-when-invalid"
              value="Batman"
              label="Batman"
              invalid
              checked
            />
            <NewCheckbox
              id="newcheckbox-when-invalid-b"
              name="newcheckbox-when-invalid"
              value="Chapulin"
              label="Chapulin Colorado"
              invalid
            />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and NewCheckbox when in error state and focused"
            error="Remember to set both Field “error” and NewCheckbox “invalid” props"
          >
            <NewCheckbox
              id="newcheckbox-when-invalid-and-focused-a"
              name="newcheckbox-when-invalid-and-focused"
              value="Batman"
              label="Batman"
              checked
              invalid
            />
            <NewCheckbox
              id="newcheckbox-when-invalid-and-focused-b"
              name="newcheckbox-group-base2"
              value="Chapulin"
              label="Chapulin Colorado"
              invalid
            />
          </Field>

          {/* Disabled state */}
          <Field label="NewCheckbox when disabled">
            <NewCheckbox
              id="newcheckbox-when-disabled-a"
              name="newcheckbox-when-disabled"
              value="Batman"
              label="Batman"
              disabled
            />
            <NewCheckbox
              id="newcheckbox-when-disabled-b"
              name="newcheckbox-when-disabled"
              value="Chapulin"
              label="Chapulin Colorado"
              disabled
              checked
            />
          </Field>

          {/* Disabled and invalid check */}
          <Field label="NewCheckbox when invalid and disabled, should just look disabled">
            <NewCheckbox
              id="newcheckbox-when-disabled-and-invalid-a"
              name="newcheckbox-when-disabled-and-invalid"
              value="Batman"
              label="Batman"
              disabled
              invalid
            />
            <NewCheckbox
              id="newcheckbox-when-disabled-and-invalid-b"
              name="newcheckbox-when-disabled-and-invalid"
              value="Chapulin"
              label="Chapulin Colorado"
              invalid
              disabled
              checked
            />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-newselect-interactive-states-test"
        key="comprehensive-newselect-interactive-states-test"
        name="Comprehensive test of NewSelect interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal NewSelect">
            <NewSelect id="normal-newselect">
              <NewSelect.Option value="" />
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
          </Field>

          {/* Hovered state */}
          <Field label="NewSelect when hovered">
            <NewSelect id="newselect-when-hovered">
              <NewSelect.Option value="" />
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
          </Field>

          {/* Focused state */}
          <Field label="NewSelect when focused">
            <NewSelect id="newselect-when-focused">
              <NewSelect.Option value="" />
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
          </Field>

          {/* With placeholder */}
          <Field label="NewSelect with placeholder">
            <NewSelect id="newselect-with-placeholder">
              <NewSelect.Option value="">Choose your favorite superhero</NewSelect.Option>
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
          </Field>

          {/* With set value */}
          <Field label="NewSelect when option is selected">
            <NewSelect id="newselect-when-option-is-selected" value="Chapulin">
              <NewSelect.Option value="" />
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
          </Field>

          {/* Side by side */}
          <Field label="NewSelect side by side">
            <NewSelect id="newselect-side-by-side-a" width="half" inline>
              <NewSelect.Option value="" />
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
            <NewSelect id="newselect-side-by-side-b" value="Chapulin" width="half" inline>
              <NewSelect.Option value="" />
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and NewSelect error states"
            error="Remember Chapulin is the biggest hero of Hispanic-America"
          >
            <NewSelect id="newselect-when-invalid" value="Batman" invalid>
              <NewSelect.Option value="" />
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and NewSelect when in error state and focused"
            error="Remember to set both Field “error” and NewSelect “invalid” props"
          >
            <NewSelect id="newselect-when-invalid-and-focused" value="Batman" invalid>
              <NewSelect.Option value="" />
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
          </Field>

          {/* Disabled state */}
          <Field label="NewSelect when disabled">
            <NewSelect id="newselect-when-disabled" value="Batman" disabled>
              <NewSelect.Option value="" />
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
          </Field>

          {/* Disabled and invalid check */}
          <Field label="NewSelect when invalid and disabled, should just look disabled">
            <NewSelect id="newselect-when-disabled-and-invalid" value="Batman" disabled invalid>
              <NewSelect.Option value="" />
              <NewSelect.Option value="Batman">Batman</NewSelect.Option>
              <NewSelect.Option value="Chapulin">Chapulin Colorado</NewSelect.Option>
            </NewSelect>
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-selectablelist-interactive-states-test"
        key="comprehensive-selectablelist-interactive-states-test"
        name="Comprehensive test of SelectableList interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal SelectableList" isStacked htmlFor="normal-selectablelist">
            <SelectableList
              id="normal-selectablelist"
              options={[
                {
                  id: 'normal-selectablelist-a',
                  value: 'Batman',
                  content: 'Batman',
                },
                {
                  id: 'normal-selectablelist-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                },
              ]}
            />
          </Field>

          {/* Hovered state */}
          <Field label="SelectableList when hovered" htmlFor="selectablelist-when-hovered" isStacked>
            <SelectableList
              id="selectablelist-when-hovered"
              options={[
                {
                  id: 'selectablelist-when-hovered-a',
                  value: 'Batman',
                  content: 'Batman',
                },
                {
                  id: 'selectablelist-when-hovered-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                },
              ]}
            />
          </Field>

          {/* Focused state */}
          <Field label="SelectableList when focused" htmlFor="selectablelist-when-focused" isStacked>
            <SelectableList
              id="selectablelist-when-focused"
              options={[
                {
                  id: 'selectablelist-when-focused-a',
                  value: 'Batman',
                  content: 'Batman',
                },
                {
                  id: 'selectablelist-when-focused-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                },
              ]}
            />
          </Field>

          {/* With set value */}
          <Field
            label="SelectableList when option is selected"
            htmlFor="selectablelist-when-option-is-selected"
            isStacked
          >
            <SelectableList
              id="selectablelist-when-option-is-selected"
              options={[
                {
                  id: 'selectablelist-when-option-is-selected-a',
                  value: 'Batman',
                  content: 'Batman',
                },
                {
                  id: 'selectablelist-when-option-is-selected-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                },
              ]}
              value="Chapulin"
            />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and SelectableList error states"
            htmlFor="selectablelist-invalid-state"
            error="Remember Chapulin is the biggest hero of Hispanic-America"
            isStacked
          >
            <SelectableList
              id="selectablelist-invalid-state"
              options={[
                {
                  id: 'selectablelist-invalid-state-a',
                  value: 'Batman',
                  content: 'Batman',
                  isInvalid: true,
                },
                {
                  id: 'selectablelist-invalid-state-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                  isInvalid: true,
                },
              ]}
              value="Batman"
            />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and SelectableList when in error state and focused"
            htmlFor="selectablelist-invalid-state-and-focused"
            error="Remember to set both Field “error” and NewSelect “invalid” props"
            isStacked
          >
            <SelectableList
              id="selectablelist-invalid-state-and-focused"
              options={[
                {
                  id: 'selectablelist-invalid-state-and-focused-a',
                  value: 'Batman',
                  content: 'Batman',
                  isInvalid: true,
                },
                {
                  id: 'selectablelist-invalid-state-and-focused-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                  isInvalid: true,
                },
              ]}
              value="Batman"
            />
          </Field>

          {/* Disabled state */}
          <Field label="SelectableList when disabled" htmlFor="selectabelist-disabled" isStacked>
            <SelectableList
              id="selectablelist-disabled"
              options={[
                {
                  id: 'selectablelist-disabled-a',
                  value: 'Batman',
                  content: 'Batman',
                  isDisabled: true,
                },
                {
                  id: 'selectablelist-disabled-b',
                  value: 'Chapulin',
                  isDisabled: true,
                  content: <span>Chapulin Colorado</span>,
                },
              ]}
              value="Batman"
            />
          </Field>

          {/* Disabled and invalid check */}
          <Field
            label="SelectableList when invalid and disabled, should just look disabled"
            htmlFor="selectablelist-disabled-and-invalid"
            isStacked
          >
            <SelectableList
              id="selectablelist-disabled-and-invalid"
              options={[
                {
                  id: 'selectablelist-disabled-and-invalid-a',
                  value: 'Batman',
                  content: 'Batman',
                  isDisabled: true,
                  isInvalid: true,
                },
                {
                  id: 'selectablelist-disabled-and-invalid-b',
                  value: 'Chapulin',
                  isDisabled: true,
                  content: <CustomText size="small">Chapulin Colorado</CustomText>,
                  isInvalid: true,
                },
              ]}
              value="Batman"
            />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-horizontal-selectablelist-interactive-states-test"
        key="comprehensive-horizontal-selectablelist-interactive-states-test"
        name="Comprehensive test of horizontal SelectableList interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal SelectableList" htmlFor="horizontal-normal-selectablelist" isStacked>
            <SelectableList
              isHorizontal
              id="horizontal-normal-selectablelist"
              options={[
                {
                  id: 'horizontal-normal-selectablelist-a',
                  value: 'Batman',
                  content: 'Batman',
                },
                {
                  id: 'horizontal-normal-selectablelist-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                },
              ]}
            />
          </Field>

          {/* Hovered state */}
          <Field label="SelectableList when hovered" htmlFor="horizontal-selectablelist-when-hovered" isStacked>
            <SelectableList
              isHorizontal
              id="horizontal-selectablelist-when-hovered"
              options={[
                {
                  id: 'horizontal-selectablelist-when-hovered-a',
                  value: 'Batman',
                  content: 'Batman',
                },
                {
                  id: 'horizontal-selectablelist-when-hovered-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                },
              ]}
            />
          </Field>

          {/* Focused state */}
          <Field label="SelectableList when focused" htmlFor="horizontal-selectablelist-when-focused" isStacked>
            <SelectableList
              isHorizontal
              id="horizontal-selectablelist-when-focused"
              options={[
                {
                  id: 'horizontal-selectablelist-when-focused-a',
                  value: 'Batman',
                  content: 'Batman',
                },
                {
                  id: 'horizontal-selectablelist-when-focused-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                },
              ]}
            />
          </Field>

          {/* With set value */}
          <Field
            label="SelectableList when option is selected"
            htmlFor="horizontal-selectablelist-when-option-is-selected"
            isStacked
          >
            <SelectableList
              isHorizontal
              id="horizontal-selectablelist-when-option-is-selected"
              options={[
                {
                  id: 'horizontal-selectablelist-when-option-is-selected-a',
                  value: 'Batman',
                  content: 'Batman',
                },
                {
                  id: 'horizontal-selectablelist-when-option-is-selected-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                },
              ]}
              value="Chapulin"
            />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and SelectableList error states"
            htmlFor="horizontal-selectablelist-invalid-state"
            error="Remember Chapulin is the biggest hero of Hispanic-America"
            isStacked
          >
            <SelectableList
              isHorizontal
              id="horizontal-selectablelist-invalid-state"
              options={[
                {
                  id: 'horizontal-selectablelist-invalid-state-a',
                  value: 'Batman',
                  content: 'Batman',
                  isInvalid: true,
                },
                {
                  id: 'horizontal-selectablelist-invalid-state-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                  isInvalid: true,
                },
              ]}
              value="Batman"
            />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and SelectableList when in error state and focused"
            htmlFor="horizontal-selectablelist-invalid-state-and-focused"
            error="Remember to set both Field “error” and NewSelect “invalid” props"
            isStacked
          >
            <SelectableList
              isHorizontal
              id="horizontal-selectablelist-invalid-state-and-focused"
              options={[
                {
                  id: 'horizontal-selectablelist-invalid-state-and-focused-a',
                  value: 'Batman',
                  content: 'Batman',
                  isInvalid: true,
                },
                {
                  id: 'horizontal-selectablelist-invalid-state-and-focused-b',
                  value: 'Chapulin',
                  content: 'Chapulin Colorado',
                  isInvalid: true,
                },
              ]}
              value="Batman"
            />
          </Field>

          {/* Disabled state */}
          <Field label="SelectableList when disabled" htmlFor="horizontal-selectablelist-disabled" isStacked>
            <SelectableList
              isHorizontal
              id="horizontal-selectablelist-disabled"
              options={[
                {
                  id: 'horizontal-selectablelist-disabled-a',
                  value: 'Batman',
                  content: 'Batman',
                  isDisabled: true,
                },
                {
                  id: 'horizontal-selectablelist-disabled-b',
                  value: 'Chapulin',
                  isDisabled: true,
                  content: <span>Chapulin Colorado</span>,
                },
              ]}
              value="Batman"
            />
          </Field>

          {/* Disabled and invalid check */}
          <Field
            label="SelectableList when invalid and disabled, should just look disabled"
            htmlFor="horizontal-selectablelist-disabled-and-invalid"
            isStacked
          >
            <SelectableList
              isHorizontal
              id="horizontal-selectablelist-disabled-and-invalid"
              options={[
                {
                  id: 'horizontal-selectablelist-disabled-and-invalid-a',
                  value: 'Batman',
                  content: 'Batman',
                  isDisabled: true,
                  isInvalid: true,
                },
                {
                  id: 'horizontal-selectablelist-disabled-and-invalid-b',
                  value: 'Chapulin',
                  isDisabled: true,
                  content: <CustomText size="small">Chapulin Colorado</CustomText>,
                  isInvalid: true,
                },
              ]}
              value="Batman"
            />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-multi-selectablelist-interactive-states-test"
        key="comprehensive-multi-selectablelist-interactive-states-test"
        name="Quick test of multi SelectableList interactive states"
      >
        <VStack>
          <SelectableList
            id="selectablelist-multi-select-invalid-1"
            multiSelect
            options={[
              {
                id: 'multiselect-selectablelist-1',
                value: false,
                isInvalid: true,
                content: <Status noIcon primaryText="Primary text" secondaryText="SelectableList secondary text" />,
              },
              {
                id: 'multiselect-selectablelist-2',
                value: true,
                isInvalid: true,
                content: <Status noIcon primaryText="Primary text" secondaryText="SelectableList secondary text" />,
              },
            ]}
            value="multiselect-selectablelist-2"
          />

          <SelectableList
            id="selectablelist-multi-select-invalid-2"
            multiSelect
            isHorizontal
            options={[
              {
                id: 'multiselect-selectablelist-3',
                value: false,
                isInvalid: true,
                content: <Status noIcon primaryText="Primary text" secondaryText="SelectableList secondary text" />,
              },
              {
                id: 'multiselect-selectablelist-4',
                value: true,
                isInvalid: true,
                content: <Status noIcon primaryText="Primary text" secondaryText="SelectableList secondary text" />,
              },
            ]}
          />
        </VStack>
      </ExposeDescribe>

      <ExposeDescribe
        id="comprehensive-newtypeahead-interactive-states-test"
        key="comprehensive-newtypeahead-interactive-states-test"
        name="Comprehensive test of NewTypeahead interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal NewTypeahead">
            <NewTypeahead
              id="newtypeahead-normal"
              value={typeaheadValue1}
              onChange={(_, { value }) => setTypeaheadValue1(value)}
              options={typeaheadOptions}
              optionLabel={typeaheadOptionLabel}
              filterOptions={typeaheadFilteredOptions}
              input={props => <NewInput {...props} id="newtypeahead-normal-input" />}
            />
          </Field>

          {/* Hovered state */}
          <Field label="NewTypeahead on hover">
            <NewTypeahead
              id="newtypeahead-on-hover"
              value={typeaheadValue1}
              onChange={(_, { value }) => setTypeaheadValue1(value)}
              options={typeaheadOptions}
              optionLabel={typeaheadOptionLabel}
              filterOptions={typeaheadFilteredOptions}
              input={props => <NewInput {...props} id="newtypeahead-on-hover-input" />}
            />
          </Field>

          {/* Focused state */}
          <Field label="NewTypeahead on focus">
            <NewTypeahead
              id="newtypeahead-on-focus"
              value={typeaheadValue1}
              onChange={(_, { value }) => setTypeaheadValue1(value)}
              options={typeaheadOptions}
              optionLabel={typeaheadOptionLabel}
              filterOptions={typeaheadFilteredOptions}
              input={props => <NewInput {...props} id="newtypeahead-on-focus-input" />}
            />
          </Field>

          {/* With placeholder text */}
          <Field label="NewTypeahead with placeholder">
            <NewTypeahead
              id="newtypeahead-with-placeholder"
              value={typeaheadValue1}
              onChange={(_, { value }) => setTypeaheadValue1(value)}
              options={typeaheadOptions}
              optionLabel={typeaheadOptionLabel}
              filterOptions={typeaheadFilteredOptions}
              input={props => (
                <NewInput {...props} id="newtypeahead-with-placeholder-input" placeholder="Favorite superhero" />
              )}
            />
          </Field>

          {/* With set value */}
          <Field label="NewTypeahead with value">
            <NewTypeahead
              id="newtypeahead-with-value"
              value="Chapulin Colorado"
              onChange={(_, { value }) => setTypeaheadValue1(value)}
              options={typeaheadOptions}
              optionLabel={typeaheadOptionLabel}
              filterOptions={typeaheadFilteredOptions}
              input={props => <NewInput {...props} id="newtypeahead-with-value-input" />}
            />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and NewTypeahead error states"
            error="Remember Chapulin Colorado is the biggest hero of Hispanic-America"
          >
            <NewTypeahead
              id="newtypeahead-invalid"
              value={typeaheadValue1}
              onChange={(_, { value }) => setTypeaheadValue1(value)}
              options={typeaheadOptions}
              optionLabel={typeaheadOptionLabel}
              filterOptions={typeaheadFilteredOptions}
              input={props => <NewInput {...props} id="newtypeahead-invalid-input" invalid />}
            />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and NewTypeahead error states and focused"
            error="Remember to set both Field “error” and NewTypeahead “invalid” props"
          >
            <NewTypeahead
              id="newtypeahead-invalid-and-focused"
              value={typeaheadValue1}
              onChange={(_, { value }) => setTypeaheadValue1(value)}
              options={typeaheadOptions}
              optionLabel={typeaheadOptionLabel}
              filterOptions={typeaheadFilteredOptions}
              input={props => <NewInput {...props} id="newtypeahead-invalid-and-focused-input" invalid />}
            />
          </Field>

          {/* Disabled state */}
          <Field label="NewTypeahead when disabled">
            <NewTypeahead
              id="newtypeahead-when-disabled"
              value="Chapulin Colorado"
              onChange={(_, { value }) => setTypeaheadValue1(value)}
              options={typeaheadOptions}
              optionLabel={typeaheadOptionLabel}
              filterOptions={typeaheadFilteredOptions}
              input={props => <NewInput {...props} id="newtypeahead-when-disabled-input" disabled />}
            />
          </Field>

          {/* Disabled and invalid check */}
          <Field
            label="NewTypeahead when invalid and disabled"
            help="Checks for potential CSS clashes disabled and invalid"
          >
            <NewTypeahead
              id="newtypeahead-when-disabled-and-invalid"
              value="Chapulin Colorado"
              onChange={(_, { value }) => setTypeaheadValue1(value)}
              options={typeaheadOptions}
              optionLabel={typeaheadOptionLabel}
              filterOptions={typeaheadFilteredOptions}
              input={props => (
                <NewInput {...props} id="newtypeahead-when-disabled-and-invalid-input" disabled invalid />
              )}
            />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-newtextarea-interactive-states-test"
        key="comprehensive-newtextarea-interactive-states-test"
        name="Comprehensive test of NewTextArea interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal NewTextArea">
            <NewTextArea id="normal-newtextarea" />
          </Field>

          {/* Hovered state */}
          <Field label="NewTextArea on hover">
            <NewTextArea id="newtextarea-on-hover" />
          </Field>

          {/* Focused state */}
          <Field label="NewTextArea on focus">
            <NewTextArea id="newtextarea-on-focus" />
          </Field>

          {/* With placeholder text */}
          <Field label="NewTextArea with placeholder">
            <NewTextArea id="newtextarea-with-placeholder" placeholder="Favorite superhero quote" />
          </Field>

          {/* With set value */}
          <Field label="NewTextArea with value">
            <NewTextArea id="newtextarea-with-value" value="¡Siganme los buenos!" />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and NewTextArea error states"
            error="Remember Chapulin Colorado is the biggest hero of Hispanic-America"
          >
            <NewTextArea id="newtextarea-invalid" value="Time is money!" invalid />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and NewTextArea error states and focused"
            error="Remember to set both Field “error” and NewTypeahead “invalid” props"
          >
            <NewTextArea id="newtextarea-invalid-with-focus" value="Time is money!" invalid />
          </Field>

          {/* Disabled state */}
          <Field label="NewTextArea when disabled">
            <NewTextArea id="newtextarea-when-disabled" value="Time is money!" disabled />
          </Field>

          {/* Disabled and invalid check */}
          <Field
            label="NewTextArea when invalid and disabled"
            help="Checks for potential CSS clashes disabled and invalid"
          >
            <NewTextArea id="newtextarea-when-disabled-and-invalid" value="Time is money!" disabled invalid />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-newdatepicker-interactive-states-test"
        key="comprehensive-newdatepicker-interactive-states-test"
        name="Comprehensive test of NewDatePicker interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal NewDatePicker">
            <NewDatePicker id="newdatepicker" value="" onChange={() => console.log('NewDatepicker onChange called')} />
          </Field>

          {/* Hovered state */}
          <Field label="NewDatePicker on hover">
            <NewDatePicker
              id="newdatepicker-on-hover"
              value=""
              onChange={() => console.log('NewDatepicker onChange called')}
            />
          </Field>

          {/* Focused state */}
          <Field label="NewDatePicker on focus">
            <NewDatePicker
              id="newdatepicker-on-focus"
              value=""
              onChange={() => console.log('NewDatepicker onChange called')}
            />
          </Field>

          {/* With placeholder text */}
          <Field label="NewDatePicker with placeholder">
            <NewDatePicker
              id="newdatepicker-with-placeholder"
              placeholder="MM/DD/YYYY"
              value=""
              onChange={() => console.log('NewDatepicker onChange called')}
            />
          </Field>

          {/* With set value */}
          <Field label="NewDatePicker with value">
            <NewDatePicker
              id="newdatepicker-with-value"
              value="08/01/1983"
              onChange={() => console.log('NewDatepicker onChange called')}
            />
          </Field>

          {/* Side by side */}
          <Field label="NewDatePicker side by side">
            <NewDatePicker
              id="newdatepicker-side-by-side-a"
              value="08/01/1983"
              onChange={() => console.log('NewDatepicker onChange called')}
              input={props => <NewInput {...props} id="newdatepicker-side-by-side-a-input" width="half" inline />}
            />
            <NewDatePicker
              id="newdatepicker-side-by-side-b"
              value="08/01/1983"
              onChange={() => console.log('NewDatepicker onChange called')}
              input={props => <NewInput {...props} id="newdatepicker-side-by-side-b-input" width="half" inline />}
            />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and NewDatePicker error states"
            error="Remember Chapulin Colorado is the biggest hero of Hispanic-America"
          >
            <NewDatePicker
              id="newdatepicker-with-value"
              value="08/01/1983"
              onChange={() => console.log('NewDatepicker onChange called')}
              invalid
            />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and DatePicker error states and focused"
            error="Remember to set both Field “error” and NewTypeahead “invalid” props"
          >
            <NewDatePicker
              id="newdatepicker-when-invalid-and-focused"
              value="08/01/1983"
              onChange={() => console.log('NewDatepicker onChange called')}
              invalid
            />
          </Field>

          {/* Disabled state */}
          <Field label="NewDatePicker when disabled">
            <NewDatePicker
              id="newdatepicker-when-disabled"
              value="08/01/1983"
              onChange={() => console.log('NewDatepicker onChange called')}
              disabled
            />
          </Field>

          {/* Disabled and invalid check */}
          <Field
            label="NewDatePicker when invalid and disabled"
            help="Checks for potential CSS clashes disabled and invalid"
          >
            <NewDatePicker
              id="newdatepicker-when-disabled-and-invalid"
              value="08/01/1983"
              onChange={() => console.log('NewDatepicker onChange called')}
              invalid
              disabled
            />
          </Field>
        </Box>
      </ExposeDescribe>

      <ExposeDescribe
        id="comprehensive-input-interactive-states-test"
        key="comprehensive-input-interactive-states-test"
        name="Comprehensive test of Input interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal Input">
            <Input id="normal-input" />
          </Field>

          {/* Hovered state */}
          <Field label="Input on hover">
            <Input id="input-on-hover" />
          </Field>

          {/* Focused state */}
          <Field label="Input on focus">
            <Input id="input-on-focus" />
          </Field>

          {/* With placeholder text */}
          <Field label="Input with placeholder">
            <Input id="input-with-placeholder" placeholder="Placeholder" />
          </Field>

          {/* With set value */}
          <Field label="Input with value">
            <Input id="input-with-value" value="Batman" />
          </Field>

          {/* With set value */}
          <Field label="Input with value">
            <Input id="input-with-value" value="Batman" size="half" isInline />
            <Input id="input-with-value" value="Batman" size="half" isInline />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and Input error states"
            error="Remember to set both Field “error” and Input “invalid” props"
          >
            <Input id="input-error-state" value="Bruce Wayne" isInvalid />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and Input error states and focused"
            error="Remember to set both Field “error” and Input “invalid” props"
          >
            <Input id="input-error-state-on-focus" value="Bruce Wayne" isInvalid />
          </Field>

          {/* Disabled state */}
          <Field label="Input when disabled">
            <Input id="input-when-disabled" value="Bruce Wayne" isDisabled />
          </Field>

          {/* Disabled and invalid check */}
          <Field label="Input when invalid and disabled" help="Checks for potential CSS clashes disabled and invalid">
            <Input id="input-disabled-and-invalid" value="Bruce Wayne" isInvalid isDisabled />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-form-components-within-table-interactive-states-test"
        key="comprehensive-form-components-within-table-interactive-states-test"
        name="Comprehensive test of different old inputs’ interactive states within the context of an old Table"
      >
        <Table headers={['Input', 'Select', 'Typeahead', 'TextArea', 'DatePicker', 'FilePicker']}>
          <TableBodyRow>
            <TableCell>
              <Input size="half" />
            </TableCell>
            <TableCell>
              <Select
                id="table-normal-select"
                size="half"
                options={[
                  {
                    label: '',
                    value: '',
                  },
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
              />
            </TableCell>
            <TableCell>
              <Typeahead
                id="table-typeahead-normal"
                size="half"
                options={[
                  {
                    label: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                  },
                ]}
              />
            </TableCell>
            <TableCell>
              <TextArea id="table-normal-textarea" size="full" />
            </TableCell>
            <TableCell>
              <DatePicker id="table-datepicker " />
            </TableCell>
            <TableCell>
              <FilePicker id="table-filepicker" size="full" />
            </TableCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableCell control>
              <Input id="editable-table-input-embedded" isCell />
            </TableCell>
            <TableCell control>
              <Select
                isCell
                id="table-normal-select-embedded"
                options={[
                  {
                    label: '',
                    value: '',
                  },
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <Typeahead
                id="table-typeahead-normal-embedded"
                isCell
                options={[
                  {
                    label: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <TextArea id="table-normal-textarea-embedded" isCell />
            </TableCell>
            <TableCell control>
              <DatePicker id="table-datepicker" isCell />
            </TableCell>
            <TableCell control>
              <FilePicker id="table-filepicker-embedded" isCell />
            </TableCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableCell control>
              <Input id="editable-table-input-hovered" isCell />
            </TableCell>
            <TableCell control>
              <Select
                isCell
                id="table-select-when-hovered"
                options={[
                  {
                    label: '',
                    value: '',
                  },
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <Typeahead
                id="table-typeahead-hover"
                isCell
                options={[
                  {
                    label: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <TextArea id="table-textarea-on-hover" isCell />
            </TableCell>
            <TableCell control>
              <DatePicker id="table-datepicker-on-hover" isCell />
            </TableCell>
            <TableCell control>
              <FilePicker id="table-filepicker-when-hovered" isCell />
            </TableCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableCell control>
              <Input id="editable-table-input-focused" isCell />
            </TableCell>
            <TableCell control>
              <Select
                isCell
                id="table-select-when-focused"
                options={[
                  {
                    label: '',
                    value: '',
                  },
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <Typeahead
                id="table-typeahead-on-focus"
                isCell
                options={[
                  {
                    label: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <TextArea id="table-textarea-on-focus" isCell />
            </TableCell>
            <TableCell control>
              <DatePicker id="table-datepicker-on-focus" isCell />
            </TableCell>
            <TableCell control>
              <FilePicker id="table-filepicker-when-focused" isCell />
            </TableCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableCell control>
              <Input id="editable-table-input-placeholder" placeholder="Batman" isCell />
            </TableCell>
            <TableCell control>
              <Select
                isCell
                id="table-select-with-placeholder"
                options={[
                  {
                    label: '',
                    value: '',
                  },
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <Typeahead
                id="table-typeahead-with-placeholder"
                placeholder="Choose superhero"
                isCell
                options={[
                  {
                    label: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <TextArea id="table-textarea-with-placeholder" placeholder="Favorite superhero quote" isCell />
            </TableCell>
            <TableCell control>
              <DatePicker id="table-datepicker-with-placeholder" placeholder="MM/DD/YYYY" isCell />{' '}
            </TableCell>
            <TableCell>N/A</TableCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableCell control>
              <Input id="editable-table-input-with-value" value="Batman" isCell />
            </TableCell>
            <TableCell control>
              <Select
                isCell
                id="table-select-when-option-is-selected"
                options={[
                  {
                    label: '',
                    value: '',
                  },
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
                value="Chapulin"
              />
            </TableCell>
            <TableCell control>
              <Typeahead
                id="table-typeahead-wiht-value"
                isCell
                value="Chapulin"
                options={[
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <TextArea id="table-textarea-with-value" value="¡Siganme los buenos!" isCell />
            </TableCell>
            <TableCell control>
              <DatePicker id="table-datepicker-with-value" value="02/01/2021" isCell />
            </TableCell>
            <TableCell control>
              <FilePicker id="table-filepicker-with-value" value={[{ name: 'Chapulin.xls' }]} isCell />
            </TableCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableCell control>
              <Input id="editable-table-input-invalid" value="Batman" isInvalid isCell />
            </TableCell>
            <TableCell control>
              <Select
                isCell
                id="table-select-when-invalid"
                options={[
                  {
                    label: '',
                    value: '',
                  },
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
                value="Batman"
                isInvalid
              />
            </TableCell>
            <TableCell control>
              <Typeahead
                id="table-typeahead-invalid"
                isCell
                isInvalid
                value="Chapulin"
                options={[
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <TextArea id="table-textarea-invalid" value="Time is money!" isInvalid isCell />
            </TableCell>
            <TableCell control>
              <DatePicker id="table-datepicker-when-invalid" value="02/27/2021" isInvalid isCell />
            </TableCell>
            <TableCell control>
              <FilePicker
                id="table-filepicker-when-invalid"
                value={[{ name: 'Batman.xls' }]}
                customError="Chapulin is the greatest hero of Hispanic-America"
                isInvalid
                isCell
              />
            </TableCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableCell control>
              <Input id="editable-table-input-invalid-and-focused" value="Batman" isInvalid isCell />
            </TableCell>
            <TableCell control>
              <Select
                isCell
                id="table-select-when-invalid-and-focused"
                options={[
                  {
                    label: '',
                    value: '',
                  },
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
                value="Batman"
                isInvalid
              />
            </TableCell>
            <TableCell control>
              <Typeahead
                id="table-typeahead-invalid-and-focused"
                isInvalid
                isCell
                value="Chapulin"
                options={[
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <TextArea id="table-textarea-invalid-with-focus" value="Time is money!" isInvalid isCell />
            </TableCell>
            <TableCell control>
              <DatePicker id="table-datepicker-when-invalid-and-focused" value="02/27/2021" isInvalid isCell />
            </TableCell>
            <TableCell control>
              <FilePicker
                id="table-filepicker-when-invalid-and-focused"
                value={[{ name: 'Batman.xls' }]}
                customError="Chapulin is the greatest hero of Hispanic-America"
                isInvalid
                isCell
              />
            </TableCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableCell control>
              <Input id="editable-table-input-disabled" value="Batman" isDisabled isCell />
            </TableCell>
            <TableCell control>
              <Select
                isCell
                isDisabled
                id="table-select-when-disabled"
                options={[
                  {
                    label: '',
                    value: '',
                  },
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
                value="Batman"
              />
            </TableCell>
            <TableCell control>
              <Typeahead
                id="table-typeahead-when-disabled"
                isCell
                isDisabled
                value="Chapulin"
                options={[
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <TextArea id="table-textarea-when-disabled" value="Time is money!" isDisabled isCell />
            </TableCell>
            <TableCell control>
              <DatePicker id="table-datepicker-when-disabled" value="02/27/2021" isDisabled isCell />
            </TableCell>
            <TableCell control>
              <FilePicker id="table-filepicker-when-disabled" value={[{ name: 'Batman.xls' }]} disabled isCell />
            </TableCell>
          </TableBodyRow>
          <TableBodyRow>
            <TableCell control>
              <Input id="editable-table-input-disabled-and-invalid" value="Batman" isDisabled isInvalid isCell />
            </TableCell>
            <TableCell control>
              <Select
                isCell
                isDisabled
                isInvalid
                id="table-select-when-disabled-and-invalid"
                options={[
                  {
                    label: '',
                    value: '',
                  },
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
                value="Batman"
              />
            </TableCell>
            <TableCell control>
              <Typeahead
                id="table-typeahead-disabled-and-invalid"
                isDisabled
                isInvalid
                isCell
                value="Chapulin"
                options={[
                  {
                    label: 'Batman',
                    value: 'Batman',
                  },
                  {
                    label: 'Chapulin Colorado',
                    value: 'Chapulin',
                  },
                ]}
              />
            </TableCell>
            <TableCell control>
              <TextArea
                id="table-textarea-when-disabled-and-invalid"
                value="Time is money!"
                isDisabled
                isInvalid
                isCell
              />
            </TableCell>
            <TableCell control>
              <DatePicker
                id="table-datepicker-when-disabled-and-invalid"
                value="02/27/2021"
                isDisabled
                isInvalid
                isCell
              />
            </TableCell>
            <TableCell control>
              <FilePicker
                id="table-filepicker-when-disabled-and-invalid"
                value={[{ name: 'Batman.xls' }]}
                disabled
                isInvalid
                isCell
              />
            </TableCell>
          </TableBodyRow>
        </Table>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-radio-interactive-states-test"
        key="comprehensive-radio-interactive-states-test"
        name="Comprehensive test of old Radio interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal Radio">
            <Radio
              id="radio-normal-state"
              name="radio-normal-state"
              options={[
                { id: 'radio-normal-state-a', label: 'Batman', value: 'Batman' },
                { id: 'radio-normal-state-b', label: 'Chapulin Colorado', value: 'Chapulin' },
              ]}
            />
          </Field>

          {/* Hovered state */}
          <Field label="Radio when hovered">
            <Radio
              id="radio-hovered-state"
              name="radio-hovered-state"
              options={[
                { id: 'radio-hovered-state-a', label: 'Batman', value: 'Batman' },
                { id: 'radio-hovered-state-b', label: 'Chapulin Colorado', value: 'Chapulin' },
              ]}
            />
          </Field>

          {/* Focused state */}
          <Field label="Radio when focused">
            <Radio
              id="radio-when-focused"
              name="radio-when-focused"
              options={[
                { id: 'radio-when-focused-a', label: 'Batman', value: 'Batman' },
                { id: 'radio-when-focused-b', label: 'Chapulin Colorado', value: 'Chapulin' },
              ]}
            />
          </Field>

          {/* With set value */}
          <Field label="Radio when checked">
            <Radio
              id="radio-when-checked"
              name="radio-when-checked"
              value="Chapulin"
              options={[
                { id: 'radio-when-checked-a', label: 'Batman', value: 'Batman' },
                { id: 'radio-when-checked-b', label: 'Chapulin Colorado', value: 'Chapulin' },
              ]}
            />
          </Field>

          {/* Side by side */}
          <Field label="Radio side by side">
            <Radio
              id="radio-side-by-side"
              name="radio-side-by-side"
              value="Chapulin"
              size="half"
              isInline
              options={[
                { id: 'radio-side-by-side-a', label: 'Batman', value: 'Batman' },
                { id: 'radio-side-by-side-b', label: 'Chapulin', value: 'Chapulin' },
              ]}
            />
          </Field>

          {/* Invalid state */}
          <Field label="Field and Radio error states" error="Remember Chapulin is the biggest hero of Hispanic-America">
            <Radio
              id="radio-when-invalid"
              name="radio-when-invalid"
              value="Batman"
              options={[
                {
                  id: 'radio-when-disabled-and-invalid-a',
                  label: 'Batman',
                  value: 'Batman',

                  isInvalid: true,
                },
                {
                  id: 'radio-when-disabled-and-invalid-b',
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',

                  isInvalid: true,
                },
              ]}
            />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and Radio when in error state and focused"
            error="Remember to set both Field “error” and Input “invalid” props"
          >
            <Radio
              id="radio-when-invalid-and-focused"
              name="radio-when-invalid-and-focused"
              value="Chapulin"
              options={[
                {
                  id: 'radio-when-disabled-and-invalid-a',
                  label: 'Batman',
                  value: 'Batman',

                  isInvalid: true,
                },
                {
                  id: 'radio-when-disabled-and-invalid-b',
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',

                  isInvalid: true,
                },
              ]}
            />
          </Field>

          {/* Disabled state */}
          <Field label="Radio when disabled">
            <Radio
              id="radio-when-disabled"
              name="radio-when-disabled"
              value="Chapulin"
              options={[
                {
                  id: 'radio-when-disabled-and-invalid-a',
                  label: 'Batman',
                  value: 'Batman',
                  isDisabled: true,
                },
                {
                  id: 'radio-when-disabled-and-invalid-b',
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                  isDisabled: true,
                },
              ]}
            />
          </Field>

          {/* Disabled and invalid check */}
          <Field label="Radio when invalid and disabled, should just look disabled">
            <Radio
              id="radio-when-disabled-and-invalid"
              name="radio-when-disabled-and-invalid"
              value="Chapulin"
              options={[
                {
                  id: 'radio-when-disabled-and-invalid-a',
                  label: 'Batman',
                  value: 'Batman',
                  isDisabled: true,
                  isInvalid: true,
                },
                {
                  id: 'radio-when-disabled-and-invalid-b',
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                  isDisabled: true,
                  isInvalid: true,
                },
              ]}
            />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-checkbox-interactive-states-test"
        key="comprehensive-checkbox-interactive-states-test"
        name="Comprehensive test of old Checkbox interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal Checkbox">
            <Checkbox id="checkbox-normal-a" label="Batman" />
            <Checkbox id="checkbox-normal-b" label="Chapulin Colorado" />
          </Field>

          {/* Hovered state */}
          <Field label="Checkbox when hovered">
            <Checkbox id="checkbox-when-hovered-a" label="Batman" />
            <Checkbox id="checkbox-when-hovered-b" label="Chapulin Colorado" />
          </Field>

          {/* Focused state */}
          <Field label="Checkbox when focused">
            <Checkbox id="checkbox-when-focused-a" label="Batman" />
            <Checkbox id="checkbox-when-focused-b" label="Chapulin Colorado" />
          </Field>

          {/* With set value */}
          <Field label="Checkbox when checked">
            <Checkbox id="checkbox-when-checked-a" label="Batman" />
            <Checkbox id="checkbox-when-checked-b" label="Chapulin Colorado" value />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and Checkbox error states"
            error="Remember Chapulin is the biggest hero of Hispanic-America"
          >
            <Checkbox id="checkbox-when-invalid-a" label="Batman" value isInvalid />
            <Checkbox id="checkbox-when-invalid-b" label="Chapulin Colorado" isInvalid />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and Checkbox when in error state and focused"
            error="Remember to set both Field “error” and Checkbox “isInvalid” props"
          >
            <Checkbox id="checkbox-when-invalid-and-focused-a" label="Batman" isInvalid />
            <Checkbox id="checkbox-when-invalid-and-focused-b" label="Chapulin Colorado" isInvalid />
          </Field>

          {/* Disabled state */}
          <Field label="Checkbox when disabled">
            <Checkbox id="checkbox-when-disabled-a" label="Batman" isDisabled />
            <Checkbox id="checkbox-when-disabled-b" label="Chapulin Colorado" isDisabled />
          </Field>

          {/* Disabled and invalid check */}
          <Field label="Checkbox when invalid and disabled, should just look disabled">
            <Checkbox id="checkbox-when-disabled-and-invalid-a" label="Batman" isDisabled isInvalid />
            <Checkbox id="checkbox-when-disabled-and-invalid-b" label="Chapulin Colorado" isDisabled isInvalid />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-select-interactive-states-test"
        key="comprehensive-select-interactive-states-test"
        name="Comprehensive test of old Select interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal Select">
            <Select
              id="normal-select"
              options={[
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
            />
          </Field>

          {/* Hovered state */}
          <Field label="Select when hovered">
            <Select
              id="select-when-hovered"
              options={[
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
            />
          </Field>

          {/* Focused state */}
          <Field label="Select when focused">
            <Select
              id="select-when-focused"
              options={[
                {
                  label: '',
                  value: '',
                },
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
            />
          </Field>

          {/* With placeholder */}
          <Field label="Select with placeholder">
            <Select
              id="select-with-placeholder"
              options={[
                {
                  label: '',
                  value: '',
                },
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
            />
          </Field>

          {/* With set value */}
          <Field label="Select when option is selected">
            <Select
              id="select-when-option-is-selected"
              options={[
                {
                  label: '',
                  value: '',
                },
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
              value="Chapulin"
            />
          </Field>

          {/* Side by side */}
          <Field label="Select side by side">
            <Select
              id="select-side-by-side-a"
              size="half"
              isInline
              options={[
                {
                  label: '',
                  value: '',
                },
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
              value="Chapulin"
            />
            <Select
              id="select-side-by-side-b"
              size="half"
              isInline
              options={[
                {
                  label: '',
                  value: '',
                },
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
              value="Chapulin"
            />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and Select error states"
            error="Remember Chapulin is the biggest hero of Hispanic-America"
          >
            <Select
              id="select-when-invalid"
              options={[
                {
                  label: '',
                  value: '',
                },
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
              value="Batman"
              isInvalid
            />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and Select when in error state and focused"
            error="Remember to set both Field “error” and Select “isInvalid” props"
          >
            <Select
              id="select-when-invalid-and-focused"
              options={[
                {
                  label: '',
                  value: '',
                },
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
              value="Batman"
              isInvalid
            />
          </Field>

          {/* Disabled state */}
          <Field label="Select when disabled">
            <Select
              isDisabled
              id="select-when-disabled"
              options={[
                {
                  label: '',
                  value: '',
                },
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
              value="Batman"
            />
          </Field>

          {/* Disabled and invalid check */}
          <Field label="Select when invalid and disabled, should just look disabled">
            <Select
              isDisabled
              isInvalid
              id="select-when-disabled-and-invalid"
              options={[
                {
                  label: '',
                  value: '',
                },
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
              value="Batman"
            />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-typeahead-interactive-states-test"
        key="comprehensive-typeahead-interactive-states-test"
        name="Comprehensive test of old Typeahead interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal Typeahead">
            <Typeahead
              id="typeahead-normal"
              options={[
                {
                  label: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                },
              ]}
            />
          </Field>

          {/* Hovered state */}
          <Field label="Typeahead on hover">
            <Typeahead
              id="typeahead-hover"
              options={[
                {
                  label: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                },
              ]}
            />
          </Field>

          {/* Focused state */}
          <Field label="Typeahead on focus">
            <Typeahead
              id="typeahead-on-focus"
              options={[
                {
                  label: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                },
              ]}
            />
          </Field>

          {/* With placeholder text */}
          <Field label="Typeahead with placeholder">
            <Typeahead
              id="typeahead-with-placeholder"
              placeholder="Choose superhero"
              options={[
                {
                  label: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                },
              ]}
            />
          </Field>

          {/* With set value */}
          <Field label="Typeahead with value">
            <Typeahead
              id="typeahead-wiht-value"
              value="Chapulin"
              options={[
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
            />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and Typeahead error states"
            error="Remember Chapulin Colorado is the biggest hero of Hispanic-America"
          >
            <Typeahead
              id="typeahead-invalid"
              isInvalid
              value="Chapulin"
              options={[
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
            />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and Typeahead error states and focused"
            error="Remember to set both Field “error” and Typeahead “invalid” props"
          >
            <Typeahead
              id="typeahead-invalid-and-focused"
              isInvalid
              value="Chapulin"
              options={[
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
            />
          </Field>

          {/* Disabled state */}
          <Field label="Typeahead when disabled">
            <Typeahead
              id="typeahead-when-disabled"
              isDisabled
              value="Chapulin"
              options={[
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
            />
          </Field>

          {/* Disabled and invalid check */}
          <Field
            label="Typeahead when invalid and disabled"
            help="Checks for potential CSS clashes disabled and invalid"
          >
            <Typeahead
              id="typeahead-disabled-and-invalid"
              isDisabled
              isInvalid
              value="Chapulin"
              options={[
                {
                  label: 'Batman',
                  value: 'Batman',
                },
                {
                  label: 'Chapulin Colorado',
                  value: 'Chapulin',
                },
              ]}
            />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-textarea-interactive-states-test"
        key="comprehensive-textarea-interactive-states-test"
        name="Comprehensive test of old TextArea interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal TextArea">
            <TextArea id="normal-textarea" size="full" />
          </Field>

          {/* Hovered state */}
          <Field label="TextArea on hover">
            <TextArea id="textarea-on-hover" />
          </Field>

          {/* Focused state */}
          <Field label="TextArea on focus">
            <TextArea id="textarea-on-focus" />
          </Field>

          {/* With placeholder text */}
          <Field label="TextArea with placeholder">
            <TextArea id="textarea-with-placeholder" placeholder="Favorite superhero quote" />
          </Field>

          {/* With set value */}
          <Field label="TextArea with value">
            <TextArea id="textarea-with-value" value="¡Siganme los buenos!" />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and TextArea error states"
            error="Remember Chapulin Colorado is the biggest hero of Hispanic-America"
          >
            <TextArea id="textarea-invalid" value="Time is money!" isInvalid />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and TextArea error states and focused"
            error="Remember to set both Field “error” and NewTypeahead “invalid” props"
          >
            <TextArea id="textarea-invalid-with-focus" value="Time is money!" isInvalid />
          </Field>

          {/* Disabled state */}
          <Field label="TextArea when disabled">
            <TextArea id="textarea-when-disabled" value="Time is money!" isDisabled />
          </Field>

          {/* Disabled and invalid check */}
          <Field
            label="TextArea when invalid and disabled"
            help="Checks for potential CSS clashes disabled and invalid"
          >
            <TextArea id="textarea-when-disabled-and-invalid" value="Time is money!" isDisabled isInvalid />
          </Field>
        </Box>
      </ExposeDescribe>
      <ExposeDescribe
        id="comprehensive-datepicker-interactive-states-test"
        key="comprehensive-datepicker-interactive-states-test"
        name="Comprehensive test of old DatePicker interactive states"
      >
        <Box>
          {/* Normal state */}
          <Field label="Normal DatePicker">
            <DatePicker id="datepicker " />
          </Field>

          {/* Hovered state */}
          <Field label="DatePicker on hover">
            <DatePicker id="datepicker-on-hover" />
          </Field>

          {/* Focused state */}
          <Field label="DatePicker on focus">
            <DatePicker id="datepicker-on-focus" />
          </Field>

          {/* With placeholder text */}
          <Field label="DatePicker with placeholder">
            <DatePicker id="datepicker-with-placeholder" placeholder="MM/DD/YYYY" />
          </Field>

          {/* With set value */}
          <Field label="DatePicker with value">
            <DatePicker id="datepicker-with-value" value="02/27/2021" />
          </Field>

          {/* Invalid state */}
          <Field
            label="Field and DatePicker error states"
            error="Remember Chapulin Colorado is the biggest hero of Hispanic-America"
          >
            <DatePicker id="datepicker-when-invalid" value="02/27/2021" isInvalid />
          </Field>

          {/* Invalid state with focus */}
          <Field
            label="Field and DatePicker error states and focused"
            error="Remember to set both Field “error” and NewTypeahead “invalid” props"
          >
            <DatePicker id="datepicker-when-invalid-and-focused" value="02/27/2021" isInvalid />
          </Field>

          {/* Disabled state */}
          <Field label="DatePicker when disabled">
            <DatePicker id="datepicker-when-disabled" value="02/27/2021" isDisabled />
          </Field>

          {/* Disabled and invalid check */}
          <Field
            label="DatePicker when invalid and disabled"
            help="Checks for potential CSS clashes disabled and invalid"
          >
            <DatePicker id="datepicker-when-disabled-and-invalid" value="02/27/2021" isDisabled isInvalid />
          </Field>
        </Box>
      </ExposeDescribe>
    </>
  );
};

export default FormComponentsExpose;
